import { useMemo } from 'react';
import { ClientConfigs, getClientConfigs } from '../../lib/Util';
import { User } from '../../system/User';

export enum ClientConfigName {
  OPC_LIQUIDACION_AGRUPADA = 'opc_liquidacion_agrupada',
}

export function useLiquidacionAgrupadaConfig(user?: User) {
  const profileId = user?.getProfile()?.getId();

  const configLiquidacionAgrupada = useMemo<ClientConfigs | undefined>(() => {
    if (!profileId) return undefined;

    return getClientConfigs().find((c) => c.cltconf_perid === profileId && c.cltconf_nombre === ClientConfigName.OPC_LIQUIDACION_AGRUPADA);
  }, [profileId]);

  return configLiquidacionAgrupada;
}
